module.exports = __webpack_public_path__ + "img/backHome_05.25233682.png";